import { mlSheetService } from '../services/mlSheetService.js';
import { shipmentService } from '../services/shipmentService.js';
import Alert from '../components/common/Alert.js';

export const deliveredStatusUrl = (shipmentId) =>
  `/update-status?select=${encodeURIComponent(shipmentId)}&status=delivered`;

export const perSheetDeliveredUrl = (mlSheetId, shipmentId) =>
  `/ml-sheets/view/${encodeURIComponent(mlSheetId)}/status-update?select=${encodeURIComponent(shipmentId)}&status=delivered`;

export function shipmentIdFromViewPath(pathname) {
  const match = String(pathname || '').match(/\/shipments\/view\/([^/?#]+)/i);
  if (!match) return '';
  try {
    return decodeURIComponent(match[1]).trim();
  } catch {
    return String(match[1] || '').trim();
  }
}

const isOnUpdateStatus = (pathname) =>
  String(pathname || '').includes('/update-status') ||
  String(pathname || '').endsWith('/status-update');

export async function resolveDeliverShortcut({ pathname, headerShipmentId, selectedCount, setDeliveredOnPage }) {
  if (isOnUpdateStatus(pathname) && selectedCount > 0) {
    setDeliveredOnPage?.();
    return { handled: true };
  }

  const fromView = shipmentIdFromViewPath(pathname) || headerShipmentId;
  if (fromView) {
    return openDeliverForShipment(fromView);
  }

  return { openModal: true };
}

export async function openDeliverForShipment(rawId) {
  const id = String(rawId || '').trim();
  if (!id) {
    Alert.error('Enter a shipment id');
    return { handled: true };
  }
  try {
    const res = await shipmentService.getShipment(id);
    const shipment = res.data?.shipment || res.data?.data;
    const shipmentId = shipment?.shipment_id || id;
    const mlSheetId = shipment?.ml_sheet_id;
    if (!mlSheetId && !shipment?.on_ml_sheet) {
      Alert.error('This shipment is not on a loading sheet yet');
      return { handled: true, error: true };
    }
    try {
      const assigned = await mlSheetService.getAgentStatusShipments(shipmentId);
      const list = assigned.data?.shipments || [];
      const match = list.find((row) => String(row.shipment_id) === String(shipmentId));
      if (!match) {
        Alert.error('This shipment is not assigned to you for status update');
        return { handled: true, error: true };
      }
    } catch {
      /* fall through to navigation — page will enforce access */
    }
    return { navigateTo: deliveredStatusUrl(shipmentId) };
  } catch (error) {
    Alert.error(error.response?.data?.error || 'Shipment not found');
    return { handled: true, error: true };
  }
}
